/** @format */

import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Base from "./components/layout/Base";
import Home from "./pages/Home";

function App() {
  return (
    <BrowserRouter>
      <Base>
        <Routes>
          <Route path='/' element={<Home />} />
        </Routes>
      </Base>
    </BrowserRouter>
  );
}

export default App;
